import GoalCreate from './GoalCreate';

export default GoalCreate;
